import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'components/ui/checkbox/Checkbox';
import Divider from 'components/ui/divider/Divider';
import List from 'components/ui/list/List';
import ListItem from 'components/ui/list/ListItem';
import styled from 'styled-components';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { CheckBoxIcon, IndeterminateCheckBoxIcon } from 'assets/materialIcons/materialIcons';
import { mandatoryFields } from './settings';

const SubTitle = styled.div`
    font-size: 18px;
    padding: 24px 0 10px;
`;

const SelectExportFields = (props) => {
    const {
        translate,
        fields,
        checkedFields,
        toggleField,
        toggleGroup,
    } = props;

    const sortByLabel = (a, b) => {
        const nameA = a.props.primaryText;
        const nameB = b.props.primaryText;

        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }

        return 0;
    };

    const renderCheckboxes = (value, group, status, disabled) => {
        return (
            <ListItem
                key={ `checkbox_${ value }` }
                primaryText={ translate(`export.fields.${ value }`) }
                leftCheckbox={
                    <Checkbox
                        disabled={ disabled }
                        checked={ status }
                        onCheck={ () => {
                            return toggleField(value, group);
                        } }
                    />
                }
            />

        );
    };

    const renderCheckboxGroups = (group, name) => {
        const fieldGroupName = name;
        const checkedFieldsInGroup = checkedFields[name];
        const isNotCompletelyActive = checkedFieldsInGroup.length !== group.length;

        return (
            <div key={ `checkboxGroup_${ name }` } >
                <Divider />

                <ListItem
                    primaryText={ translate(`export.field_groups.${ name }`) }
                    leftCheckbox={ <Checkbox
                        onCheck={ () => {
                            return toggleGroup(!checkedFieldsInGroup.length, fieldGroupName);
                        } }
                        checked={ !!checkedFieldsInGroup.length }
                        checkedIcon={ isNotCompletelyActive ? <IndeterminateCheckBoxIcon /> : <CheckBoxIcon /> }
                    /> }
                    initiallyOpen={ false }
                    onNestedListToggle={ props.onToggle }
                    nestedItems={
                        utils.map(group, (field) => {
                            return renderCheckboxes(field, fieldGroupName, !!~checkedFieldsInGroup.indexOf(field));
                        }).sort(sortByLabel)
                    }
                    primaryTogglesNestedList={ false }
                />
            </div>
        );
    };

    return (
        <div>
            <SubTitle>
                { translate('export.description') }
            </SubTitle>

            <List>
                <ListItem
                    primaryText={ translate('export.field_groups.default') }
                    leftCheckbox={ <Checkbox
                        disabled={ true }
                        checked={ true }
                    /> }
                    initiallyOpen={ false }
                    nestedItems={
                        utils.map(mandatoryFields, (field) => {
                            return renderCheckboxes(field, 'default', true, true);
                        }).sort(sortByLabel)
                    }
                    primaryTogglesNestedList={ false }
                    onNestedListToggle={ props.onToggle }
                />

                {
                    utils.map(fields, (fieldGroup, key) => {
                        return renderCheckboxGroups(fieldGroup, key);
                    })
                }
            </List>
        </div>
    );
};

SelectExportFields.defaultProps = {
    onToggle: function () {},
};

SelectExportFields.propTypes = {
    checkedFields: PropTypes.object.isRequired,
    fields: PropTypes.object.isRequired,
    onToggle: PropTypes.func,
    toggleField: PropTypes.func.isRequired,
    toggleGroup: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(SelectExportFields);



// WEBPACK FOOTER //
// ./src/pages/reservations/list/actions/csv/SelectExportFields.js